import {BaseApiModel} from "../../../../infrastructure/models/base-api-model";
import {DateFormatApiModel} from "./date-format-api-model";

const DATE_DESKTOP_PICKER_FORMAT = 'ccc, do MMM';
const SHORT_DAY_NAMED = 'ccc';
const LONG_DATE_NAMED = 'cccc, do MMMM';
const SHORT_MONTH_NAME = 'MMM';
const DATE_TIME_DESKTOP_PICKER_FORMAT = 'ccc, do MMM - HH:mm';

export class DateFormatDomainModel extends BaseApiModel {
  localeName: String;
  shortDatePattern: String;
  shortestDatePattern: String;
  shortTimePattern: String;
  longTimePattern: String;
  fullDateTimePattern: String;
  firstDayOfWeek: Number;
  use24Clock: Boolean;
  desktopPickerPattern: String;
  shortDesktopPickerPattern: String;
  shortDayNamedPattern: String;
  longDateNamedPattern: String;
  shortMonthNamePattern: String;
  desktopDateTimeNamedPattern: String;

  constructor(model: DateFormatApiModel,shortTimePattern: String, longTimePattern: String, fullDateTimePattern: String) {
    super();

    this.localeName = model.localeName;
    this.shortDatePattern = model.ShortDatePattern;
    this.shortestDatePattern = model.ShortestDatePattern;
    this.shortTimePattern = shortTimePattern;
    this.longTimePattern = longTimePattern;
    this.fullDateTimePattern = fullDateTimePattern;
    this.firstDayOfWeek = model.FirstDayOfWeek;
    this.use24Clock = model.Use24Clock;
    this.desktopPickerPattern = model.DateDesktopPickerFormat || DATE_DESKTOP_PICKER_FORMAT;
    this.shortDesktopPickerPattern = model.ShortDayDateDesktopPickerFormat || DATE_DESKTOP_PICKER_FORMAT;
    this.shortDayNamedPattern = SHORT_DAY_NAMED;
    this.longDateNamedPattern = model.LongDateNamedPattern || LONG_DATE_NAMED;
    this.shortMonthNamePattern = SHORT_MONTH_NAME;
    this.desktopDateTimeNamedPattern = model.DesktopDateTimeNamedPattern || DATE_TIME_DESKTOP_PICKER_FORMAT;
  }
}
